import { AddCircle, PauseCircle, SunFog, CloseCircle, DocumentText1, Clock, Airplane } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";

export const STATUS_MAP = {
  pending_documents: {
    label: "status.pending_documents",
    color: "gray",
    icon: <DocumentText1 size={14} color="currentColor" />,
  },
  pending_approval: {
    label: "status.pending_approval",
    color: "gray",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  active: {
    label: "status.active",
    color: "positive",
    icon: <CheckIcon />,
  },
  annual_leave: {
    label: "status.vacation",
    color: "gray",
    icon: <SunFog size={14} color="currentColor" />,
  },
  unpaid_leave: {
    label: "status.unpaid",
    color: "gray",
    icon: <PauseCircle size={14} color="currentColor" variant="Bold" />,
  },
  medical_leave: {
    label: "status.medical_leave",
    color: "negative",
    icon: <AddCircle size={14} color="currentColor" variant="Bold" />,
  },
  business_trip: {
    label: "status.businessTrip",
    color: "info",
    icon: <Airplane size={14} color="currentColor" variant="Bold" />,
  },
  inactive: {
    label: "status.inactive",
    color: "gray",
    icon: <PauseCircle size={14} color="currentColor" variant="Bold" />,
  },
  resigned: {
    label: "status.resigned",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
} as const;
